import script from "./LlCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./LlCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./LlCheckbox.vue?vue&type=style&index=0&id=3856e7d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3856e7d0"]])

export default __exports__